import { render, staticRenderFns } from "./SystemVisits.vue?vue&type=template&id=c4ea71b8&"
import script from "./SystemVisits.vue?vue&type=script&lang=js&"
export * from "./SystemVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports